import { useState, useEffect } from "react";
import { FaEdit, FaTrashAlt, FaPlus, FaCheckCircle } from "react-icons/fa";
import { AiFillSetting } from 'react-icons/ai'
import { Button } from "antd";
import { Link } from 'react-router-dom'

import Switch from "../../component/switch/Index";
import Styled from "styled-components";
import Swal from 'sweetalert2'

import Service from '../../service/Mgt-station'
import TableControl from "../../component/table/TableControl";

const ButtonAddStation = Styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #05BC9B;
  color : white;
  width: fit-content;
  font-size : 16px;
  height: 40px;
`

export default function TableListAllStation(props) {

  const [columns, setColumns] = useState([])
  
  useEffect(() => {
    initColumn(props.permission)
  }, [props.permission, props.data]);

  const onToggleAllowPublic = async (id, allowPublic) => {
    let result = await Service.updateAllowPublic(id, {allowPublic})
    if(result){
      props.fncSetData(props.data.map(item => item.id == result.id ? {...item, allow_public: result.allow_public} : item))
    }
  }

  const onUpdateStatus = async (id, status) =>{
    let result = await Service.updateStatus(id, {status})
    if(result){
      props.fncSetData(props.data.map(item => item.id == result.id ? {...item, status: result.status} : item))
    }else{
      props.fncSetData(props.data)
    }
  }

  const onDelete = async (id, stationName) => {
    Swal.fire({
      icon: 'question',
      title: `ยืนยันการลบสถานี${stationName}`,
      showCancelButton: true,
      confirmButtonText: `ยืนยัน`,
      cancelButtonText: `ยกเลิก`,
    }).then( async (result) => {
      if (result.isConfirmed) {
        let result = await Service.delete(id)
        if(result){
          Swal.fire({
            title: `ลบสถานี ${stationName} สำเร็จ`,
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
          }).then(function() {
            props.fncSetData(props.data.filter(item => item.id != result.id))
          })
        }
      } 
    })
  }

  const buttonCreateStation = () => (
    <Link to={'/mgt-station/create'}>
      <ButtonAddStation className='btn-add-data' 
      icon={<FaPlus className='icon-add-data' />} >
        เพิ่มสถานี
      </ButtonAddStation>
    </Link>
  )

  const initColumn = (permission) =>{
    const column = [
      { title: "สถานี", dataIndex: "name_th", align: "center", className: "cn allow-search", sorter: (a, b) => a.name_th.localeCompare(b.name_th), },
      { title: "จังหวัด", dataIndex: "province", align: "center", className: "cn allow-search", sorter: (a, b) => a.province.localeCompare(b.province), },
      { title: "สถานะ", dataIndex: "status", align: "center", className: "cn", sorter: (a, b) => a.status - b.status,
      render: (_, record) => (
        <Switch checkedChildren="เปิดใช้งาน" unCheckedChildren="ปิดใช้งาน" checked={record.status == 1 ? true : false} onChange={()=>{
          onUpdateStatus(record.id, record.status == 0 ? 1 : 0)
        }}/>
      )},
      { title: "แสดงสาธารณะ", dataIndex: "allow_public", align: "center", className: "cn", sorter: (a, b) => a.allow_public - b.allow_public,
      render: (_, record) => (
        record.allow_public ? (
          <Button
            className="btn-record__allow-public"
            onClick={()=>{onToggleAllowPublic(record.id, false)}}>
              <FaCheckCircle style={{color: "#5FDBA7"}}/>
          </Button>
        ) : (
          <Button
            className="btn-record__allow-public"
            onClick={()=>{onToggleAllowPublic(record.id, true)}}>
              <FaCheckCircle style={{color: "#EBEBE4"}}/>
          </Button>
        )
      )},
      
    ];

    if(permission.indexOf("update") >= 0 || permission.indexOf("delete") >= 0){
      column.push({ title: <AiFillSetting/>, dataIndex: "", align: "center",className:"cell-action",
      render: (_, record) => (
        <> 
        {props.permission.indexOf('update') >= 0 ? ( 
        <Link to={'/mgt-station/'+record.id}>
          <Button className="btn-edit-data"><FaEdit /></Button>
        </Link>) : (<></>)}
        {props.permission.indexOf('delete') >= 0 ? ( 
       <Button 
          className="btn-delete-data"
          onClick={()=>{onDelete(record.id, record.name_th)}}>
              <FaTrashAlt  />
        </Button>) : (<></>)}
        </>
      )
      })
    }

    setColumns(column)
  }
  

  

  return (
    <TableControl
      className={
        "table-mgt-list-station" +
        (props.className ? props.className : "")
      }
      topRightButton = {props.permission.indexOf('create') >= 0 ? buttonCreateStation() : ''}
      data={props.data}
      filterData={props.filterData} 
      fncSetFilterData={props.fncSetFilterData}
      columns={columns}
      dataSet={1}
    />
  );
}

